import { Browsers } from '@phosphor-icons/react';
import { Pages } from './Pages';

import { CopilotHooks, HookObject, ListItemsHooks } from "@/plugins/types";
import { Dashboard } from "./Dashboard";
import { Preview } from './Page/Preview';
import get_pages from './prompts/get_pages';
import get_page from './prompts/get_page';
import { convertPagetoHTML } from './utils';

export const onListItems = (hook: HookObject, _, __, { permissions = [] }) => {
  if (hook.id === ListItemsHooks.APP_DRAWER && hook.position === "top") {
    if (!permissions.includes("pages")) return [];
    return [
      {
        label: "Pages",
        icon: <Browsers className="text-lg" />,
        href: "/pages",
        order: 1,
      },
    ];
  }

  if (hook.id === ListItemsHooks.ROUTES) {
    // if (!permissions.includes("pages")) return [];
    return [
      {
        path: "/pages",
        element: <Pages name="Pages" />,
        children: [
          {
            path: ":campaignId",
            element: <Dashboard name="Pages" />,
          },
        ],
      },
      {
        path: "/pages/preview/:campaignId/:objectId/:pageId",
        element: <Preview />
      },
      {
        path: "/pages/preview/:campaignId/:objectId",
        element: <Preview />
      },
    ];
  }
};

export const onChatPrompt = (
  hook: HookObject,
  { context },
  { copilotContext }
) => {
  if (
    hook.id === CopilotHooks.GET_SYSTEM_PROMPT &&
    context[0]?.label === "Pages" &&
    copilotContext
  ) {

    console.log("(Pages) About to System Prompt", context, copilotContext);

    // retrieve the page content
    let systemPrompt = "";

    if (context[0]?.label === "Pages") systemPrompt += get_pages(copilotContext['Pages']);      
    if (copilotContext['Page Content']) systemPrompt += get_page(copilotContext["Page Content"]);

    return systemPrompt;
  }

  if (
    hook.id === CopilotHooks.GET_GRAPH_STATE &&
    (context[0]?.label === "Pages")
  ) {

    console.log("Current Copilot Context", copilotContext);

    // if the first context is "Pages," the second one is the page name
    const pageName = context[1]?.label;
    const pageContent = copilotContext[pageName];
    
    console.log("(Pages) About to send graph state", pageName);

    return {
      pageContent: JSON.parse(pageContent),
      pageHTML: convertPagetoHTML(JSON.parse(pageContent)),
      // currentContent: JSON.parse(pageContent),
    }
  }
};

export { Pages };